var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3682 14.716C13.0953 13.6385 11.5234 11.323 11.5234 8.64041C11.5234 4.92906 14.5321 1.92041 18.2434 1.92041C21.9548 1.92041 24.9634 4.92906 24.9634 8.64041C24.9634 11.323 23.3916 13.6385 21.1186 14.716",
    stroke: "#0645FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3616 24.0003C15.3616 22.4095 14.0723 21.1203 12.4816 21.1203C10.8908 21.1203 9.60156 22.4095 9.60156 24.0003V30.7203C9.60156 38.6729 16.0489 45.1203 24.0016 45.1203C31.9542 45.1203 38.4016 38.6729 38.4016 30.7203V24.0003C38.4016 22.4095 37.1123 21.1203 35.5216 21.1203C33.9308 21.1203 32.6416 22.4095 32.6416 24.0003V22.0803C32.6416 20.4895 31.3523 19.2003 29.7616 19.2003C28.1708 19.2003 26.8816 20.4895 26.8816 22.0803V20.1603C26.8816 18.5695 25.5923 17.2803 24.0016 17.2803C22.4108 17.2803 21.1216 18.5695 21.1216 20.1603V8.64025C21.1216 7.04953 19.8323 5.76025 18.2416 5.76025C16.6508 5.76025 15.3616 7.04953 15.3616 8.64025V29.7603V24.0003Z",
    stroke: "#353535",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "adreel-static/media/f2.59d758ed5e521039304b1ae571038d77.svg";
export { ForwardRef as ReactComponent };